// extracted by mini-css-extract-plugin
export default {"top":"TableParty_top_EKpk5","handle":"TableParty_handle_FLvdz"};